import { render, staticRenderFns } from "./UpdateChecker.vue?vue&type=template&id=a74b4b26"
import script from "./UpdateChecker.vue?vue&type=script&lang=ts"
export * from "./UpdateChecker.vue?vue&type=script&lang=ts"
import style0 from "./UpdateChecker.vue?vue&type=style&index=0&id=a74b4b26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports